import React from "react"
import PropTypes from "prop-types"

import MenuItem from './MenuItem';
import SettingMenuItem from './SettingMenuItem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons'

class SideNav extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      settingMenu: false
    }

    this.toggleSettings = this.toggleSettings.bind(this)
    this.handleLogout = this.handleLogout.bind(this)
  }

  componentWillUnmount() {
    this.setState({
      settingMenu: false
    })
  }

  handleLogout = () => {
    const link = document.createElement('a');
    link.setAttribute('href', '../logout');
    link.setAttribute('rel', 'nofollow');
    link.setAttribute('data-method', 'delete');
    document.body.appendChild(link);
    link.click();
  }

  toggleSettings() {
    this.setState({
      settingMenu: !this.state.settingMenu,
    })
  }

  // onTwitterClick() {
  //   window.open(`//twitter.com/intent/tweet?text=Learning%20a%20language?%20Practice speaking,%20in%20person,%20with%20native%20speakers%20on%20%40LexodyApp!%20Use%20my%20code:%20www.lexody.com/?referral_code=LEX50${this.props.user.id}`, "_blank")
  // }
  // onFbClick() {
  //   window.open(`//www.facebook.com/sharer/sharer.php?u=https%3A//www.lexody.com/?referral_code=LEX50${this.props.user.id}`, "_blank")
  // }

  render() {
    if (this.state.settingMenu) {
        return(
          <div style={{float: 'right'}}>
            <div className="sideMenu">
              <div style={{display: 'flex', alignItems: 'center', margin: 10, cursor: 'pointer'}}>
                <FontAwesomeIcon
                  icon={faArrowLeft}
                  className="lightBlue"
                  style={{fontSize: 16, marginRight: 10}}
                  onClick={() => this.setState({ settingMenu: false })}
                />
                <h4 className="sectionHeader" style={{textAlign: 'left', marginLeft: 15, lineHeight: 'unset'}}>SETTINGS</h4>
              </div>
              <SettingMenuItem
                title="My Information"
                onClick={() => window.location.replace(`../edit`)}
              />
              <SettingMenuItem
                title="Languages"
                onClick={() => window.location.replace(`../my_languages`)}
              />
              <SettingMenuItem
                title="Who Can Contact Me"
                onClick={() => window.location.replace(`../pro_settings`)}
              />
              <SettingMenuItem
                title="Notifications"
                onClick={() => window.location.replace(`../notification_settings`)}
              />
            </div>
            <div
              onClick={() => this.props.toggleMenu()}
              style={{width: '200vh', height: '100vh', position: 'inherit', top: 0, left: 0}}></div>
        </div>
        )
    } else {
      return(
        <div style={{float: 'right'}}>
          <div className="sideMenu">
            <MenuItem
              iconName="profileIcon menuItemImg"
              title="PROFILE"
              onClick={() => window.location.replace(`../profile/${this.props.currentUserSlug}`)}
            />
            <MenuItem
              iconName="settingsIcon menuItemImg"
              title="SETTINGS"
              onClick={() => this.toggleSettings()}
            />
            <MenuItem
              iconName="membershipIcon menuItemImg"
              title="PRO MEMBERSHIP"
              onClick={() => window.location.replace(`../pricing`)}
            />
            {!this.props.premiumUser &&
            <MenuItem
              iconName="lexicoinIcon menuItemImg"
              title="BUY LEXICOINS"
              onClick={() => window.location.replace(`../pricing?one_time=true`)}
            />}
            <MenuItem
              iconName="blogIcon menuItemImg"
              title="BLOG - LANGUAGE RESOURCES"
              onClick={() => window.location.replace(`../blog`)}
            />
            <MenuItem
              iconName="supportIcon menuItemImg"
              title="SUPPORT"
              onClick={() => window.location.replace(`../welcome/contact`)}
            />
            <MenuItem
              iconName="logoutIcon menuItemImg"
              title="SIGN OUT"
              onClick={this.handleLogout}
            />

          </div>
          <div
            onClick={() => this.toggleMenu()}
            style={{width: '200vh', height: '100vh', position: 'inherit', top: 0, left: 0}}></div>

        </div>
      )
    }
  }
}

export default SideNav
